import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Transicion2020 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 95; i <= 101; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
	kits:[],
        kit_path: '/images_fem/kits/todas/',
      id_list: id_list,
      table1:[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':7, 'pg':4,'pe':1,'pp':2,'gf':23,'gc':18,'dif':5, 'pts':13},
	      {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':7, 'pg':1,'pe':0,'pp':6,'gf':10,'gc':36,'dif':-26, 'pts':3},
	      {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':7, 'pg':3,'pe':2,'pp':2,'gf':14,'gc':13,'dif':1, 'pts':11},
	      {'color':0,'shortname':'vial', 'rivalName':'Fernández Vial', 'pj':7, 'pg':1,'pe':1,'pp':5,'gf':14,'gc':21,'dif':-7, 'pts':4},
	      {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':7, 'pg':0,'pe':1,'pp':6,'gf':6,'gc':34,'dif':-28, 'pts':1},
	      {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':7, 'pg':5,'pe':1,'pp':1,'gf':25,'gc':8,'dif':17, 'pts':16},
	      {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':7, 'pg':7,'pe':0,'pp':0,'gf':42,'gc':6,'dif':36, 'pts':21},
	      {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':7, 'pg':4,'pe':0,'pp':3,'gf':19,'gc':17,'dif':2, 'pts':12}]
    };
  }

  componentDidMount() {
		let newtable = this.sortTable(this.state.table1);
	this.getKits();
  		this.setState({table1:newtable});
	}
 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}




  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){

  let subD = this.subText('#E42727', 'Desciende a Primera B');
  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  return(

	<div style={{textAlign: 'center' }}>
	     <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Transición 2020</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>


         {subT}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Transicion 2020</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Transicion 2020 </div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Transicion 2020" />
     </div>


  )
}

}
export default Transicion2020;
